var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user box-shadow padding10" },
    [
      _c("dc-panel", { attrs: { title: "账号管理" } }, [
        _c(
          "div",
          { staticClass: "user" },
          [
            _c(
              "div",
              { staticClass: "flex marginBottom10" },
              [
                _c(
                  "el-input",
                  {
                    staticClass: "input-with-select",
                    attrs: { clearable: "", placeholder: "请输入手机号码" },
                    model: {
                      value: _vm.queryPara.userName,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryPara, "userName", $$v)
                      },
                      expression: "queryPara.userName",
                    },
                  },
                  [
                    _c("el-button", {
                      attrs: { slot: "append", icon: "el-icon-search" },
                      on: { click: _vm.doSearch },
                      slot: "append",
                    }),
                  ],
                  1
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "marginLeftAuto",
                    attrs: { type: "primary" },
                    on: { click: _vm.addUser },
                  },
                  [_vm._v("新增账号")]
                ),
              ],
              1
            ),
            _c(
              "dc-datatable",
              {
                ref: "list",
                attrs: { url: _vm.urlApi, params: _vm.queryPara },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    type: "index",
                    label: "序号",
                    index: _vm.indexMethod,
                    width: "100",
                  },
                }),
                _c("el-table-column", {
                  attrs: { align: "center", label: "账号类型", width: "170" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "marginLeft10" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.userType === "0"
                                    ? "系统账号"
                                    : scope.row.userType === "1"
                                    ? "加盟商账号"
                                    : "商户账号"
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "userName",
                    label: "账号",
                    width: "200",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "marginLeft10" }, [
                            _vm._v(" " + _vm._s(scope.row.userName) + " "),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "nickName",
                    label: "用户名",
                    width: "200",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "marginLeft10" }, [
                            _vm._v(" " + _vm._s(scope.row.nickName) + " "),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "remark",
                    label: "角色权限",
                    width: "160",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_vm._v(" " + _vm._s(scope.row.roleName) + " ")]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "status",
                    label: "状态",
                    width: "100",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", {}, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.status === "1" ? "禁止" : "启用"
                                ) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "address",
                    label: "操作",
                    width: "160",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-dropdown",
                            {
                              attrs: { trigger: "click" },
                              on: { command: _vm.handlePwd },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { color: "#f8ac59" },
                                  attrs: { size: "mini", type: "text" },
                                },
                                [_vm._v("修改密码")]
                              ),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: { command: 1, row: scope.row },
                                      },
                                    },
                                    [_vm._v("重置密码")]
                                  ),
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        command: { command: 2, row: scope.row },
                                      },
                                    },
                                    [_vm._v("修改密码")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.updateUser(scope.row.userId)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "red",
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteUser(scope.row)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }